<template>
  <div>
    <v-data-table
      hide-actions
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
      class="elevation-1 mt-3"
    >
      <template #items="props">
        <td>
          <v-icon small :color="props.item.online ? 'success' : 'error'">circle</v-icon>
        </td>
        <td>{{ props.item.adminid }}</td>
        <td>
          <template v-if="props.item.check_in_time">
            {{ props.item.check_in_time | DateFormat('DD/MM/YYYY HH:mm') }}
          </template>
          <template v-else>-</template>
        </td>
        <td>
          <template v-if="props.item.check_out_time">
            {{ props.item.check_out_time | DateFormat('DD/MM/YYYY HH:mm') }}
          </template>
          <template v-else>-</template>
        </td>
        <td>
          <template v-if="props.item.check_in_time && props.item.check_out_time">
            {{ getDurationTime(props.item.check_in_time, props.item.check_out_time) }}
          </template>
          <template v-else>-</template>
        </td>
        <td>
          <v-btn flat icon color="primary" @click="() => handleViewPerformanceByAgent(props.item)">
            <v-icon>search</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <AgentDialog
      :agent-id.sync="agentDialog.agentId"
      :open.sync="agentDialog.isOpen"
      :online.sync="agentDialog.isOnline"
      :total-seconds="totalSeconds"
      @export="handleExportAgentTime"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import AgentDialog from './AgentDialog.vue'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import * as XLSX from 'xlsx'
dayjs.extend(customParseFormat)

export default {
  components: {
    AgentDialog
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataList: [],
      pagination: { rowsPerPage: -1, sortBy: 'online', descending: true },
      headers: [
        {
          text: 'Status',
          value: 'online',
          sortable: false
        },
        {
          text: 'Agent',
          value: 'agent',
          sortable: false
        },
        {
          text: 'Check-in time',
          value: 'checkInTime',
          sortable: false
        },
        {
          text: 'Check-out time',
          value: 'checkOutTime',
          sortable: false
        },
        {
          text: 'Duration',
          sortable: false
        },
        {
          text: 'Action',
          sortable: false
        }
      ],
      agentDialog: {
        isOpen: false,
        agentId: null,
        isOnline: false
      },
      totalSeconds: 0
    }
  },
  methods: {
    handleExportAgentTime(rawData, selectData, agentId) {
      let sumDiff = 0
      let jsonExport = []
      jsonExport.push([
        agentId,
        `From ${selectData.start ? dayjs(selectData.start).format('DD/MM/YYYY') : '-'} to ${
          selectData.end ? dayjs(selectData.end).format('DD/MM/YYYY') : '-'
        }`
      ])
      jsonExport.push('')
      jsonExport.push(['Date', 'Check-in time', 'Check-out time', 'Duration'])
      let datalist = []
      for (let i = 0; i < rawData.length; i++) {
        const dayData = rawData[i]
        let maxLengthData = dayData.checkin
        if (dayData.checkout.length > maxLengthData.length) {
          maxLengthData = dayData.checkout
        }
        if (dayData.diff.length > maxLengthData.length) {
          maxLengthData = dayData.diff
        }
        for (let k = 0; k < maxLengthData.length; k++) {
          datalist.push([
            dayjs(dayData.date).format('DD/MM/YYYY'),
            dayData.checkin[k] ? dayData.checkin[k] : '',
            dayData.checkout[k] ? dayData.checkout[k] : '',
            dayData.diff[k] ? this.timer(dayData.diff[k]) : ''
          ])
        }

        sumDiff += dayData.sumDiff
      }
      jsonExport = [...jsonExport, ...datalist]
      jsonExport.push(['Total', '', '', this.timer(sumDiff)])
      const wb = XLSX.utils.book_new()
      const dataWS1 = XLSX.utils.json_to_sheet(jsonExport)
      XLSX.utils.book_append_sheet(wb, dataWS1, 'Data')
      XLSX.writeFile(wb, 'export.xlsx')
    },
    timer(value) {
      const hours = Math.floor(value / 60 / 60)
      const minutes = Math.ceil(value / 60) % 60
      return `${hours} hours ${minutes} minutes`
    },
    getDurationTime(from, to) {
      const diff = dayjs(to).diff(dayjs(from), 'second')
      const display = this.transformDurationTime(diff)
      return display
    },
    transformDurationTime(value) {
      const hours = Math.floor(value / 3600)
      const minutes = Math.floor((value % 3600) / 60)

      const hDisplay = hours > 0 ? `${hours}  ${this.$t('Hours')}` : ''
      const mDisplay = minutes > 0 ? ` ${minutes} ${this.$t('Minutes')}` : ''
      return `${hDisplay} ${mDisplay}`
    },
    handleViewPerformanceByAgent(agent) {
      this.agentDialog.agentId = agent.adminid
      this.agentDialog.isOnline = agent.online
      this.totalSeconds = this.getDurationTime(agent.check_in_time, agent.check_out_time)
      this.agentDialog.isOpen = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/agents/WorkTime/DataTable.vue